<template>
 <div>
  <button class="prev left" @click="$emit('prev')">
   <img :src="require('@/landings/LE_NEW/sign.svg')" alt="">
  </button>
  <button class="right" @click="$emit('next')"><img :src="require('@/landings/LE_NEW/sign.svg')" alt=""></button>
 </div>
</template>

<script>
 export default {
  emits: ['prev', 'next'],
}
</script>

<style lang="sass" scoped>
button
  background: transparent
  border: none
  display: inline-block
  position: absolute
  height: 97px
  width: 48px
  top: calc( 50% - 25px )
  color: #f3f3f3
  cursor: pointer  
  img
    position: relative
    z-index: 1000
.prev
  transform: rotate(180deg)  
.left
  left:0
//  margin-right: -60px
.right
  right: 0
@media screen and (max-width: 630px)
  button
    img
      height: 40px
</style>